<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-08 20:14:35
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-07-15 17:04:03
 * @Description: 动态内容
 -->

<template>
  <div class="news-content-wrapper">
    <h3 class="title">{{ title }}</h3>
    <div v-html="htmlBody"></div>
  </div>
</template>
<script>
export default {
  name: 'news-content-wrapper',
  data() {
    return {
      htmlBody: '',
      title: ''
    };
  },
  created() {
    this.requestContent();
  },
  methods: {
    async requestContent() {
      const res = await this.$http.post('cg/commonRequest', {
        method: 'pinfo.trend.detail',
        // method: 'content.trend.detail',
        token: '',
        trendid: this.$route.params.id,
        terminal: 4,
        label: ''
      });
      if (res.code === 200) {
        this.title = res.data.title;
        this.htmlBody = res.data.body;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.news-content-wrapper {
  .title {
    text-align: center;
    font-size: 20px;
    line-height: 50px;
    color: #666;
    margin-bottom: 20px;
  }
}
</style>
